import { TokenName } from '@mews/design-tokens';
import { isIn } from '@mews/std';
import { getToken } from '@optimus-web/core';

export const DATAVIZ_COLORS = {
    blue: getToken(TokenName.backgroundDatavizBlue),
    orange: getToken(TokenName.backgroundDatavizOrange),
    green: getToken(TokenName.backgroundDatavizGreen),
    red: getToken(TokenName.backgroundDatavizRed),
    purple: getToken(TokenName.backgroundDatavizPurple),
    pink: getToken(TokenName.backgroundDatavizPink),
} as const;

export const SEMANTIC_DATAVIZ_COLORS = {
    negative: getToken(TokenName.textAlertDanger),
    positive: getToken(TokenName.textAlertSuccess),
    neutral: getToken(TokenName.textAlertWarning),
} as const;

const UTILITY_COLORS = {
    disabled: getToken(TokenName.backgroundInteractiveNeutralHover),
} as const;

export type DatavizColor = keyof typeof DATAVIZ_COLORS;
export type UtilityDatavizColor = keyof typeof UTILITY_COLORS;
export type SemanticDatavizColor = keyof typeof SEMANTIC_DATAVIZ_COLORS;

export type DatavizPalette = DatavizColor | UtilityDatavizColor;

export const getDataVizColor = (index: number, color?: DatavizPalette) => {
    if (color) {
        if (isIn(color, DATAVIZ_COLORS)) {
            return DATAVIZ_COLORS[color];
        }
        if (isIn(color, UTILITY_COLORS)) {
            return UTILITY_COLORS[color];
        }
    }

    const keys = Object.keys(DATAVIZ_COLORS) as DatavizColor[];

    return DATAVIZ_COLORS[keys[index % keys.length]];
};

export const getDataVizSemanticColor = (color: SemanticDatavizColor) => SEMANTIC_DATAVIZ_COLORS[color];
